import { render, staticRenderFns } from "./downfile.vue?vue&type=template&id=f56991a2&scoped=true&"
import script from "./downfile.vue?vue&type=script&lang=js&"
export * from "./downfile.vue?vue&type=script&lang=js&"
import style0 from "./downfile.vue?vue&type=style&index=0&id=f56991a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56991a2",
  null
  
)

export default component.exports